<div class="reset-password-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
            >
                <div class="title text-center">
                    <h3>
                        Reset Mot de passe?
                    </h3>
                    <p class="ml-auto mr-auto">
                        Entrer your Nouveau Mot de passe and confirm it another time in the field below.
                    </p>
                </div>
   <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label class="main-label d-block lh-1 text-black">Password</label>
    <mat-form-field appearance="fill">
      <mat-label>Entrer le mot de passe</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <span class="material-symbols-outlined">{{hide ? 'visibility_off' : 'visibility'}}</span>
      </button>
    </mat-form-field>
  </div>
  <div class="form-group">
    <label class="main-label d-block lh-1 text-black">Confirm Password</label>
    <mat-form-field appearance="fill">
      <mat-label>Confirm password</mat-label>
      <input matInput [type]="hide2 ? 'password' : 'text'" formControlName="confirmPassword" />
      <button mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
        <span class="material-symbols-outlined">{{hide2 ? 'visibility_off' : 'visibility'}}</span>
      </button>
    </mat-form-field>
  </div>

  <button mat-button class="btn" type="submit" [disabled]="resetPasswordForm.invalid">Send</button>

  <div *ngIf="message" class="success-message">{{ message }}</div>
  <div *ngIf="error" class="error-message">{{ error }}</div>

  <div class="text-center back-to-sign-in">
    <a mat-button routerLink="/authentication">
      <i class="ri-arrow-left-s-line"></i> Retour pour se connecter
    </a>
  </div>
</form>

            </div>
        </div>
    </div>
</div>